module.exports = __webpack_public_path__ + "static/media/digsafOH.16291083.png";